var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-template',{attrs:{"contained":_vm.containTemplate,"navigation":_vm.interiorNavigationItems}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }